import { isEmpty } from 'lodash';

export default {
  watch: {
    'form.personal_profile.receive_via_email': 'changeInvoiceEmail'
  },

  methods: {
    changeInvoiceEmail() {
      if (
        !this.form.personal_profile.invoice_email &&
        !isEmpty(this.form.user) &&
        this.form.personal_profile.receive_via_email
      ) {
        this.form.personal_profile.invoice_email = this.form.user.email;
      }
    }
  }
};
